"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorIndicatorStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../../shared/styles");
var ColorIndicatorStyled = exports.ColorIndicatorStyled = _styledComponents.default.div.withConfig({
  displayName: "ColorIndicatorstyled__ColorIndicatorStyled",
  componentId: "sc-wifz2w-0"
})(["background:", ";border-radius:", ";"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'm' ? _styles.borderRadius.s : '3px';
});